const Spinner = (props) => (
  <span className='relative flex size-3' {...props}>
    <span className='bg-primary absolute inline-flex h-full w-full animate-ping rounded-full opacity-75'></span>
    <span className='bg-primary relative inline-flex size-3 rounded-full'></span>
  </span>
);
export default Spinner;
